package com.parmartechnologies.storage.store

import com.parmartechnologies.storage.constant.KeyConstant
import com.parmartechnologies.storage.database.DatabaseConfig
import com.russhwolf.settings.Settings
import com.russhwolf.settings.get
import com.russhwolf.settings.set

class UserDefaults {
    init {
        instance = this
    }

    companion object {
        private const val TAG = "SHARED_KOTLIN"
        private var instance: UserDefaults? = null
        fun shared(): UserDefaults {
            if (instance != null) {
                return instance as UserDefaults
            } else {
                instance = UserDefaults()
                val currentDbVersion = DatabaseConfig.VERSION
                val lastDbVersion = instance?.retrieveInt("database_version")
                if(lastDbVersion != 0 && lastDbVersion == currentDbVersion ){
                    instance?.clearAll()
                    instance?.store("database_version",currentDbVersion)
                }
                return instance!!
            }
        }
    }
    private val settings: Settings = Settings()

    fun clearAll(){

    }

    fun storeCredentials(value: String) {
        settings[KeyConstant.userCredentials] = value
    }

    fun retrieveCredentials(): String {
        return settings.getString(KeyConstant.userCredentials, "")
    }

    fun storeMembership(value: String) {
        settings.putString(KeyConstant.membershipDetails, value)
    }

    fun retrieveMembership(): String {
        return settings.get(KeyConstant.membershipDetails, "")
    }

    fun store(key: String, value: String) {
        settings.putString(key, value)
    }
    fun store(key: String, value: Int) {
        settings.putInt(key, value)
    }

    fun retrieve(key: String): String {
        return settings.getString(key, "")
    }
    fun retrieveInt(key: String): Int {
        return settings.get(key, 0)
    }

    fun retrieveMembership(key: String): String {
        return settings.getString(key, "")
    }

    fun remove(key: String) {
        settings.remove(key)
    }


}